import React from "react";
import { Route, Navigate } from "react-router-dom";
import { Slug } from "../constants";
import { getToken } from "../service/AuthService";

const PublicRoute = ({ children, to = Slug.surveyInitial }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const jobToken = queryParameters.get("job_id");
  return !getToken() ? (
    children
  ) : (
    <Navigate to={jobToken ? `${to}/?job_id=${jobToken}` : to} />
  );
};

export default PublicRoute;
